import { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import {
  useLoadDismissablePromptsByType,
  useShouldStartDismissablePrompt,
} from '@ms/yammer-hooks/dist/dismissablePromptsByType';
import type { ReactNode } from 'react';
import React, { Suspense } from 'react';

import LoadableMaintenanceOutageBanner from './LoadableMaintenanceOutageBanner';
import LoadableOutageBanner from './LoadableOutageBanner';
import LoadableScheduledMaintenanceOutageBanner from './LoadableScheduledMaintenanceOutageBanner';
import type { BannerProps } from './types';

const outagePromptTypes: DismissablePromptType[] = [
  DismissablePromptType.LIVE_SITE_ISSUE,
  DismissablePromptType.MAINTENANCE_OUTAGE,
  DismissablePromptType.MAINTENANCE_OUTAGE_SCHEDULED,
];
type UseOutageBanner = (args?: BannerProps) => ReactNode;
export const useOutageBanner: UseOutageBanner = ({ entryPoint } = {}) => {
  useLoadDismissablePromptsByType(outagePromptTypes);

  const shouldShowLiveSiteBanner = useShouldStartDismissablePrompt(DismissablePromptType.LIVE_SITE_ISSUE);
  const shouldShowMaintenanceBanner = useShouldStartDismissablePrompt(DismissablePromptType.MAINTENANCE_OUTAGE);
  const shouldShowScheduledMaintenanceBanner = useShouldStartDismissablePrompt(
    DismissablePromptType.MAINTENANCE_OUTAGE_SCHEDULED
  );

  if (shouldShowLiveSiteBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  if (shouldShowMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableMaintenanceOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  if (shouldShowScheduledMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableScheduledMaintenanceOutageBanner entryPoint={entryPoint} />
      </Suspense>
    );
  }

  return null;
};
